'use strict';

var processInclude = require('base/util');

$(() => {
    processInclude(require('./product/detail'));
    processInclude(require('./product/imageZoom'));
});
